module.exports = __webpack_public_path__ + "static/media/blog4.1231aa7f.jpg";